export enum WalletCurrencyType {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  PLN = 'PLN',
  CHF = 'CHF',
  ZAR = 'ZAR',
  SGD = 'SGD',

  HKD = 'HKD',
  MAD = 'MAD',
}
